import { useContext, useMemo } from "react";
import AuthContext from "./authContext";
import { recommendFromUsers } from "../services/planRecommendationService";

export function usePlanRecommendation() {
  const auth = useContext(AuthContext);
  const companyId = auth?.userProfile?.companyId || auth?.userProfile?.id || null;
  const users = auth?.userProfile?.employees || [];

  return useMemo(
    () => recommendFromUsers(users, companyId),
    [users, companyId, auth?.userProfile?.employeesLength]
  );
}
